import React, { useState, useEffect } from "react";
import { apiService } from "../../utils/api";
import { FaHistory, FaCalendarAlt, FaClock, FaCheckCircle } from "react-icons/fa";
import "./SubscriptionDetails.css";

function SubscriptionDetails() {
  const [subscriptionData, setSubscriptionData] = useState({
    lastPayment: null,
    pendingPayment: null,
    upcomingPayment: null,
    history: [],
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    fetchSubscriptionDetails();
  }, []);

  const fetchSubscriptionDetails = async () => {
    try {
      setLoading(true);
      // Replace with your actual API endpoint
      const response = await apiService.getStudentSubscriptionDetails();
      if (response.data.success) {
        console.log("response.data.data", response.data);
        setSubscriptionData(response.data);
      } else {
        setError("Failed to load subscription details");
      }
    } catch (err) {
      setError(err.response?.data?.message || "Error loading subscription details");
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    return new Date(dateString).toLocaleDateString("en-IN", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  };

  const formatAmount = (amount) => {
    return new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency: "INR",
    }).format(amount);
  };

  if (loading) {
    return (
      <div className="subscription-container">
        <div className="loading">Loading subscription details...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="subscription-container">
        <div className="error-message">{error}</div>
      </div>
    );
  }

  return (
    <div className="subscription-container">
      <h2 className="page-title">Subscription Details</h2>
      {/* Payment Status Cards */}
      <div className="payment-status-cards">
        {subscriptionData.lastPayment && (
        <div className="status-card last-payment">
          <div className="card-icon">
            <FaCheckCircle />
          </div>
          <div className="card-content">
            <h3>Last Payment</h3>
            <p className="date">{formatDate(subscriptionData.lastPayment?.date)}</p>
              <p className="amount">{formatAmount(subscriptionData.lastPayment?.amount)}</p>
            </div>
          </div>
        )}

        {subscriptionData.pendingPayment && (
          <div className="status-card pending-payment">
            <div className="card-icon">
              <FaClock />
            </div>
            <div className="card-content">
              <h3>Pending Payment</h3>
              <p className="date">{formatDate(subscriptionData.pendingPayment?.date)}</p>
              <p className="amount">{formatAmount(subscriptionData.pendingPayment?.amount)}</p>
            </div>
          </div>
        )}

        {subscriptionData.upcomingPayment && (
          <div className="status-card upcoming-payment">
            <div className="card-icon">
              <FaCalendarAlt />
            </div>
            <div className="card-content">
              <h3>Upcoming Payment</h3>
              <p className="date">{formatDate(subscriptionData.upcomingPayment?.date)}</p>
              <p className="amount">{formatAmount(subscriptionData.upcomingPayment?.amount)}</p>
            </div>
          </div>
        )}
      </div>

      {/* Subscription History */}
      <div className="subscription-history">
        <h3 className="history-title">
          <FaHistory /> Payment History
        </h3>
        <div className="history-table-container">
          <table className="history-table">
            <thead>
              <tr>
                <th>Date</th>
                <th>Start Date</th>
                <th>End Date</th>
                <th>Plan</th>
                <th>Amount</th>
                <th>Status</th>
                <th>Transaction ID</th>
              </tr>
            </thead>
            <tbody>
              {subscriptionData.history.map((payment, index) => (
                <tr key={index}>
                  <td>{formatDate(payment.createdAt)}</td>
                  <td>{formatDate(payment.startDate)}</td>
                  <td>{formatDate(payment.endDate)}</td>
                  <td>{payment.planType.toUpperCase()}</td>
                  <td>{formatAmount(payment.amount)}</td>
                  <td>
                    <span className={`status-badge ${payment.status.toLowerCase()}`}>{payment.status}</span>
                  </td>
                  <td>{payment.transactionId}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default SubscriptionDetails;
